// src/components/ReportBug.jsx
// Help → Report a bug (3.83.0, owner): what went wrong, in the person's own
// words; the page, version, browser and errors caught go with it. Emailed to
// admin@ and kept in All feedback (kind bug). No screenshots: they can show
// patient details. Uses no providers, so the crash screen can show it too.
import { useState } from 'react';
import { auth, API_BASE } from '../firebase/config';
import { recentErrors, version } from '../utils/bugWatch';
import MenuDialog from './MenuDialog';

export function BugForm({ page, onSent }) {
  const [message, setMessage] = useState('');
  const [doing, setDoing] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  async function submit(e) {
    e.preventDefault();
    if (!message.trim()) { setError('Please say what went wrong.'); return; }
    setBusy(true); setError('');
    try {
      const token = await auth.currentUser.getIdToken();
      const r = await fetch(`${API_BASE}/portal/feedback`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'bug', message, doing, page: page || window.location.pathname, version, browser: navigator.userAgent, errors: recentErrors() }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "Couldn't send it. Please try again.");
      setDone(true);
      onSent?.();
    } catch (err) { setError(err.message); setBusy(false); }
  }
  if (done) return <p style={S.done}>Thank you. Your bug report went to Fax Portal support.</p>;
  return (
    <form onSubmit={submit}>
      <label style={S.label} htmlFor="bug-what">What went wrong?</label>
      <textarea id="bug-what" value={message} onChange={e => setMessage(e.target.value)} rows={4} maxLength={4000} style={S.box} />
      <label style={S.label} htmlFor="bug-doing">What were you doing? (optional)</label>
      <textarea id="bug-doing" value={doing} onChange={e => setDoing(e.target.value)} rows={2} maxLength={1000} style={S.box} />
      <p style={S.note}>Please don't include patient details.</p>
      {error && <p role="alert" style={S.error}>{error}</p>}
      <button type="submit" disabled={busy} style={S.send}>{busy ? 'Sending…' : 'Send'}</button>
    </form>
  );
}

export default function ReportBug({ page, onClose }) {
  return (
    <MenuDialog id="report-bug" icon="🐞" title="Report a bug" sub="Tell us what went wrong. We'll add the page, version and browser for you." onClose={onClose} width={520}>
      <div style={{ padding: '4px 20px 20px' }}><BugForm page={page} /></div>
    </MenuDialog>
  );
}

const S = {
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--t-37474f)', margin: '12px 0 6px' },
  box: { width: '100%', boxSizing: 'border-box', padding: '9px 11px', border: '1.5px solid var(--c-cfd8dc)', borderRadius: 8, fontSize: 14, fontFamily: 'inherit', resize: 'vertical', background: 'var(--c-ffffff)', color: 'var(--t-333333)' },
  note: { margin: '8px 0 10px', fontSize: 12, color: 'var(--t-78909c)' },
  error: { margin: '0 0 10px', fontSize: 13, color: 'var(--t-b71c1c)' },
  send: { padding: '9px 20px', background: 'var(--c-00897b)', color: 'var(--c-ffffff)', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit' },
  done: { margin: '12px 0', fontSize: 14, color: 'var(--t-2e7d32)', fontWeight: 600 },
};
